export default {"src":"/_next/static/media/usdt.6d35925e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};